import React from "react";
import _ from "lodash";
import { renderLayout } from "schema/ThemeSet.react";
import { Scales } from "schema/FormSchema.react";
import OptionButton from "slides/components/OptionButton.react";
import StarScale from "slides/components/StarScale.react";

export default class Rating extends React.Component {
    handleClick = (index) => {
        this.props.trackInteraction(index);
    };

    mainContent = (design) => {
        switch (design) {
            case "3 Stars":
                return (
                    <StarScale
                        {...this.props}
                        max={3}
                        size="massive"
                        handleClick={this.handleClick}
                    />
                );
            case "4 Stars":
                return (
                    <StarScale
                        {...this.props}
                        max={4}
                        size="massive"
                        handleClick={this.handleClick}
                    />
                );
            case "5 Stars":
                return (
                    <StarScale
                        {...this.props}
                        max={5}
                        size="massive"
                        handleClick={this.handleClick}
                    />
                );
            case "7 Stars":
                return (
                    <StarScale
                        {...this.props}
                        max={7}
                        size="huge"
                        handleClick={this.handleClick}
                    />
                );
            case "10 Stars":
                return (
                    <StarScale
                        {...this.props}
                        max={10}
                        size="large"
                        handleClick={this.handleClick}
                    />
                );
            default:
                return _.map(Scales[design], (option, index) => {
                    return (
                        <OptionButton
                            {...this.props}
                            layout={
                                design === "Binary Scale"
                                    ? "grid"
                                    : this.props.layout
                            }
                            fluid
                            index={index}
                            key={"button-" + index}
                            name={"" + option}
                            handleClick={this.handleClick}
                        />
                    );
                });
        }
    };

    render() {
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let LayoutRender = renderLayout(isPortrait, this.props.layout);
        let rating = this.props.data.rating && typeof this.props.data.rating !== 'string' ?
            this.props.data.rating[0]
            : this.props.data.rating;
        return (
            <div className="full-height">
                <LayoutRender
                    {...this.props}
                    title={"Choose an option:"}
                    mainContent={this.mainContent(rating)}
                />
            </div>
        );
    }
}
